import {
  ADMIN, CAMPAIGN_MANAGER, CAMPAIGN_MANAGER_CR, CAMPAIGN_MANAGER_FILES, CART_QMB_PLANT_APPROVER, CART_PLANT_SUPERVISOR, CAUSER_APPROVER_CR, CENTER_VIEWER,
  CENTER_VIEWER_CR, COMMITTEE_COORDINATOR, COMMITTEE_COORDINATOR_CR, CREATOR, CREATOR_CR, CREATOR_EXTERNAL, CREATOR_EXTERNAL_CR, APPROVER, CAUSER_PRE_APPROVER_CR,
  CAUSER_CHECK_APPROVER_CR, QMB_PLANT_APPROVER_CR, INFORMER_CHECK_APPROVER_CR, E4_PLANT_SUPERVISOR_CR, INFORMER_APPROVER_CR, RD_COMMITTEE_COORDINATOR, RD_COMMITTEE_COORDINATOR_CR, REPORTER, REPORTER_CR,
  REQUESTER_CR, statusCampaign, statusSubCampaign, VAN_CAMPAIGN_MANAGER, VAN_CAMPAIGN_MANAGER_CR, VAN_COMMITTEE_COORDINATOR, VAN_COMMITTEE_COORDINATOR_CR, VAN_E2_QMB_APPROVER, VAN_E2_QMB_APPROVER_CR, VAN_E3_CAUSER, VAN_E3_CAUSER_CR,
  VAN_E3_CHIEF_ENGINEER_CARLINE, VAN_E3_CHIEF_ENGINEER_CARLINE_CR, VAN_E3_QMB_PLANT_APPROVER, VAN_E3_QMB_PLANT_APPROVER_CR,
  WORKFLOW_TYPE, ADMIN_CR, STAND_IN_CR, INFORMER_PRE_APPROVER_CR, CAMPAIGN_RECIPIENT_CR, APPROVER_CR,
  CAMPAIGN_MANAGER_JV, APPROVER_JV, QMB_PLANT_APPROVER_JV, CREATOR_JV,
} from '@/helpers/constants';

export type VisibilityMatrixRole = typeof CREATOR | typeof CREATOR_EXTERNAL | typeof COMMITTEE_COORDINATOR | typeof CENTER_VIEWER
  | typeof CAMPAIGN_MANAGER | typeof CAMPAIGN_MANAGER_FILES | typeof REPORTER | typeof RD_COMMITTEE_COORDINATOR | typeof CART_PLANT_SUPERVISOR
  | typeof CART_PLANT_SUPERVISOR | typeof CART_QMB_PLANT_APPROVER | typeof APPROVER | typeof ADMIN | typeof VAN_COMMITTEE_COORDINATOR | typeof VAN_E3_CAUSER
  | typeof VAN_E3_CHIEF_ENGINEER_CARLINE | typeof VAN_E3_QMB_PLANT_APPROVER | typeof VAN_E2_QMB_APPROVER | typeof VAN_CAMPAIGN_MANAGER | typeof ADMIN_CR
  | typeof CAMPAIGN_MANAGER_JV | typeof APPROVER_JV | typeof QMB_PLANT_APPROVER_JV | typeof CREATOR_JV;

export type CRMatrixRole = typeof CREATOR_CR | typeof CREATOR_EXTERNAL_CR | typeof REQUESTER_CR | typeof APPROVER_CR | typeof CAUSER_APPROVER_CR | typeof INFORMER_APPROVER_CR
  | typeof CAMPAIGN_MANAGER_CR | typeof COMMITTEE_COORDINATOR_CR | typeof RD_COMMITTEE_COORDINATOR_CR | typeof QMB_PLANT_APPROVER_CR | typeof E4_PLANT_SUPERVISOR_CR
  | typeof CAUSER_PRE_APPROVER_CR | typeof CAUSER_CHECK_APPROVER_CR | typeof CAUSER_CHECK_APPROVER_CR | typeof INFORMER_CHECK_APPROVER_CR | typeof CENTER_VIEWER_CR
  | typeof REPORTER_CR | typeof VAN_COMMITTEE_COORDINATOR_CR | typeof VAN_E3_CAUSER_CR | typeof VAN_E3_CHIEF_ENGINEER_CARLINE_CR
  | typeof VAN_E3_QMB_PLANT_APPROVER_CR | typeof VAN_E2_QMB_APPROVER_CR | typeof VAN_CAMPAIGN_MANAGER_CR | typeof INFORMER_PRE_APPROVER_CR | typeof ADMIN_CR |
  typeof STAND_IN_CR | typeof CAMPAIGN_RECIPIENT_CR;

export enum VisibilityMatrixAction {
  SEARCH = 'search',
  PROFILE = 'profile',
  ALERT = 'alert',
  BURGER_MENU = 'burgerMenu',
  CART_LOGO = 'cartLogo',
  SUPPORT = 'support',
  CAMPAIGNS = 'campaigns',
  ADMINISTRATION = 'administration',
  EDIT_TITLE = 'editTitle',
  DELETE = 'delete',
  SHOW_SUMMARY = 'showSummary',
  FULL_CR = 'fullCR',
  SEND_TO_APPROVAL = 'sendToApproval',
  ASSIGN_TO = 'assignTo',
  SEND_TO_REVIEW = 'sendToReview',
  SAVE = 'save',
  SHOW_CHANGES = 'showChanges',
  MAKE_DECISION = 'makeDecision',
  CONFIRM_KNOWLEDGE = 'confirmKnowledge',
  CAMPAIGN_TABS = 'campaignTabs',
  TRANSLATIONS_TAB = 'translationsTab',
  PLANT_FEEDBACK_TAB = 'plantFeedbackTab',
  ASSIGN_CREATOR = 'assignCreator',
  COPY = 'copy',
  ASSIGN = 'assign',
  APPROVE_ALL_SUB_CRS_BY_CC = 'approveAllSubCRsByCC',
  MAKE_DECISSION_SUB_CRS_BY_CC = 'makeDecissionSubCRsByCC',
  SHOW_SUMMARY_SUB_CR = 'showSummarySubCR',
  FULL_CR_SUB_CR = 'fullCRSubCR',
  MAKE_DECISION_SUB_CR = 'makeDecisionSubCR',
  SEND_TO_APPROVAL_SUB_CR = 'sendToApprovalSubCR',
  ASSIGN_MANAGER_OVERVIEW = 'assignManagerOverview',
  ASSIGN_MANAGER = 'assignManager',
  COMPLETE_SUB_CR = 'completeSubCR',
}

export enum VisibilityMatrixFeature {
  HEADER = 'header',
  SETTINGS = 'settings',
  LEFT_MENU = 'leftMenu',
  CAMPAIGN_REQUEST = 'campaignRequest',
  CAMPAIGN_OVERVIEW = 'campaignOverview',
  SUB_CR = 'subCR',
};

export type StatusCampaign = typeof statusCampaign[keyof typeof statusCampaign];
export type StatusSubCampaign = typeof statusSubCampaign[keyof typeof statusSubCampaign];
export type WorkflowType = typeof WORKFLOW_TYPE[keyof typeof WORKFLOW_TYPE];

export type StatusToRole =
  { [key in keyof typeof statusSubCampaign]?: VisibilityMatrixRole[] }
  | { [key in keyof typeof statusCampaign]?: VisibilityMatrixRole[] };

type WorkflowStatus = {
  [key in keyof typeof WORKFLOW_TYPE]?: {
    [key in keyof typeof statusSubCampaign | keyof typeof statusCampaign]?: VisibilityMatrixRole[];
  };
};

type ActionDetails =
  WorkflowStatus
  | StatusToRole
  | VisibilityMatrixRole[];

export type VisibilityMatrix = {
  [key in VisibilityMatrixFeature]: {
    [key in VisibilityMatrixAction]?: ActionDetails
  }
};

export type VisibilityMatrixProperties = {
  feature: VisibilityMatrixFeature;
  action: VisibilityMatrixAction;
  workflow?: WorkflowType;
  status?: StatusCampaign | StatusSubCampaign;
};
